import { specialistRequests } from "api/specialistApi";
import React from "react";
import { Button, required, TextInput, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import GradingIcon from "@mui/icons-material/Grading";
import { settings } from "app";

const UpdateEstimationsDialog = ({ specialistId, curriculumItemId, fetchModules }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      estimations: [
        {
          curriculumItemId: curriculumItemId,
          estimation: data.estimation,
        },
      ],
    };

    await dataProvider.customRequest(
      specialistRequests.updateSpecialistCurriculumItemEstimations(specialistId),
      payload,
      "PUT",
    );
    fetchModules();
    refresh();
    notify("Успешно добавяне на оценка", { type: "success" });
  };

  return (
    <FormModal
      titleContent={"Добави оценка"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Оценка"
          variant="contained"
          startIcon={<GradingIcon />}
        />
      }
    >
      <TextInput
        source="estimation"
        label="Оценка"
        sx={settings.style.textAria}
        variant="outlined"
        validate={required()}
        fullWidth
        multiline
      />
    </FormModal>
  );
};

export default UpdateEstimationsDialog;
